import sc from 'styled-components';

import {Layout, ShevronDownIcon, UnifonTheme} from '@phonectas/unifon-ui-kit';

export const StyledInfoBox = sc(Layout)<{theme: UnifonTheme}>`
	background-color: #F3F3F5;
	border-radius: ${({theme}) => theme.borderRadius * 2}px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	height: 96px;
	width: 100%;
	min-width: 183px;
	padding: 10px;
	flex-wrap: nowrap;
`;

export const StyledHeaderWarning = sc(Layout)<{theme: UnifonTheme}>`
	background-color: #001B74;
	padding: 15px;
	border-radius: ${({theme}) => {
		const radius = theme.borderRadius * 2;
		return `${radius}px ${radius}px 0 0`;
	}};
`;

export const StyledCustomerBox = sc(Layout)<{theme: UnifonTheme}>`
	background-color: #F3F3F5;
	border-radius: ${({theme}) => theme.borderRadius * 2}px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	height: 110px;
    width: 100%;
    max-width: 180px;
	padding: 10px;
`;

export const StyledShevronIcon = sc(ShevronDownIcon)<{theme: UnifonTheme}>`
	color: ${({theme}) => theme.palette.primary};
	transitions: transform 100ms;
`;

export const StyledShevronButton = sc.button<{$open: boolean}>`
	cursor: pointer;
	border: 0;
	box-sizing: border-box;
	position: relative;
	display: flex;
	align-items: start;
	justify-content: space-between;
	background-color: transparent;
	padding: 8px 0px 0px 0px;
	width: auto;
	${({$open}) => `${StyledShevronIcon} {
		transform: rotate(${!$open ? '180deg' : '0deg'});
	}`}
`;

export const StyledNpsGrid = sc.div`
	display: grid; 
	grid-template-columns: 1fr 0.2fr; 
	grid-template-rows: 1fr auto 1fr; 
	gap: 0px 0px;
	min-width: 180px;
	min-height: 150px;
	grid-template-areas: 
	"na action"
	"divider divider"
	"sat sat";
`;

export const StyledNpsActionLayout = sc(Layout)`
	grid-area: action;
`;

export const StyledNpsSatisfactionLayout = sc(Layout)`
	grid-area: sat;
	display: flex;
	justify-content: center;
	width: 100%;
`;

export const StyledNpsNameLayout = sc(Layout)`
	grid-area: na;
	display: flex;
	justify-content: center;
	width: 100%;
`;
export const StyledNpsDivider = sc.div`
	grid-area: divider;
	width: 100%;
`;

export const StyledAiLayout = sc(Layout)<{theme: UnifonTheme}>`
	width: 100%;
	display: flex;
	flex-direction: row;
	background-color: ${({theme}) => theme.palette.success};
`;